var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M21.1929 9.91797L19.4465 11.2832C19.4687 11.4941 19.4877 11.7402 19.4877 12C19.4877 12.1211 19.4838 12.2402 19.4772 12.3535C19.4697 12.4824 19.4588 12.6055 19.4465 12.7188L21.1945 14.084C21.5191 14.3418 21.6078 14.7969 21.4011 15.1758L19.585 18.3184C19.391 18.6719 18.9659 18.8535 18.5345 18.6953L16.4738 17.8672C16.0788 18.1523 15.6647 18.3926 15.2364 18.5859L14.9229 20.7715C14.8715 21.1855 14.5104 21.5 14.0837 21.5H10.4421C10.0154 21.5 9.65521 21.1855 9.60449 20.7773L9.29022 18.584C8.87536 18.3965 8.46771 18.1602 8.05523 17.8672L5.98901 18.6953C5.6018 18.8457 5.13867 18.6777 4.94634 18.3242L3.12786 15.1777C2.91339 14.8164 3.00201 14.3457 3.33373 14.082L5.08013 12.7168C5.05242 12.4492 5.039 12.2168 5.039 12C5.039 11.7832 5.05242 11.5508 5.08013 11.2832L3.33215 9.91602C3.00756 9.6582 2.91967 9.20312 3.12628 8.82617L4.94238 5.68359C5.13635 5.33008 5.55749 5.14648 5.99291 5.30469L8.05364 6.13281C8.44787 5.84961 8.86193 5.60742 9.29022 5.41406L9.60375 3.23047C9.63397 2.98633 9.77081 2.77539 9.9652 2.64453C10.1017 2.55273 10.2665 2.5 10.4429 2.5H14.0845C14.5113 2.5 14.8722 2.81445 14.9229 3.22266L15.2372 5.41406C15.652 5.60156 16.059 5.83984 16.4722 6.13281L18.5384 5.30469C18.5846 5.28711 18.6316 5.27344 18.6794 5.26367C18.7349 5.25195 18.7914 5.24609 18.8488 5.24609C19.1559 5.24609 19.4386 5.41406 19.581 5.67383L21.4051 8.83398C21.5076 9.02148 21.5356 9.23047 21.496 9.42383C21.4573 9.61328 21.3541 9.78906 21.1929 9.91797ZM16.1338 10.2457C16.3927 9.96763 16.3771 9.53235 16.099 9.27349C15.8209 9.01464 15.3856 9.03024 15.1267 9.30835L11.3772 13.3368L9.36297 11.462C9.08487 11.2031 8.64958 11.2187 8.39073 11.4968C8.13187 11.7749 8.14748 12.2102 8.42558 12.4691L10.9433 14.8125C11.2214 15.0714 11.6567 15.0558 11.9156 14.7777L16.1338 10.2457Z",
          fill: "#5021D1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }